<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" sm="5" md="4">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="5" md="4">
              <div class="text-right align-end justify-end d-flex">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="datatableItems"
          :search="search"
          :items-per-page="10"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': $t('rowsPerPage'),
          }"
        >
          <template v-slot:item.withdraw_id="{ item }">
            <v-btn @click="$copy(item.withdraw_id)" x-small>
              {{ item.withdraw_id }}
            </v-btn>
          </template>

          <template v-slot:item.type_key="{ item }">
            <span v-if="item.nome_metodo == 'Carteira'">
              <v-icon>mdi-dots-horizontal</v-icon>
            </span>
            <span v-else>{{ item.type_key }}</span>
          </template>

          <template v-slot:item.ip="{ item }">
            <span v-if="item.ip">{{ item.ip }}</span>
            <v-icon v-else>mdi-dots-horizontal</v-icon>
          </template>

          <template v-slot:item.id_player="{ item }">
            <v-btn @click="$copy(item.id_player)" x-small>
              {{ item.id_player }}
            </v-btn>
          </template>

          <template
            v-for="(value, index) in valueColors"
            v-slot:[`item.${value}`]="{ item }"
          >
            <span class="caption" :key="index" :class="getColor(item[value])">
              {{ item[value] }}
            </span>
          </template>

          <template v-slot:item.statusUI="{ item }">
            <div v-html="item.statusUI"></div>
          </template>

          <!-- ACTIONS -->

          <template v-slot:item.actions="{ item }">
            <div v-show="item.showAction && item.status == 1">
              <UpdateWithdraw
                :id_withdraw="item.withdraw_id"
                :user_id="item.id_player"
                :user_name="item.name_player"
                :entry="item.value_consolidated"
                :id_gateway="item.id_gateway"
                v-on:withdrawCanceled="withdrawCanceled"
                v-on:withdrawSuccess="withdrawSuccess"
                :canAuthorizeWithdraw="canAuthorizeWithdraw"
              />
            </div>
            <div v-show="item.showAction && item.status == 4">
              <ReasonCancelled :item="item" />
            </div>
            <div v-show="!item.showAction" class="ml-3">
              <v-icon>{{ item.statusIcon }}</v-icon>
            </div>
          </template>
        </v-data-table>
      </v-card>
      <!-- Resume -->
      <div class="mt-4" v-if="datatableItems != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in resumePeriod"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">{{ TranslateKey(item) }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume[item].value)"
                      >
                        {{ resume[item].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import ReasonCancelled from "./reasonCancelledWithdrawal.vue";
import UpdateWithdraw from "./updateWithdraw.vue";
import HeaderPrint from "@/components/common/header-print";
export default {
  components: {
    UpdateWithdraw,
    ReasonCancelled,
    HeaderPrint,
  },
  data: () => ({
    resumePeriod: [],
    valueColors: ["value_requested"],
    // Datatable
    search: "",
    datatableItems: [],

    // body request
    date_start: "",
    date_final: "",
    status: "",
    dialog: false,
    headers: [],
  }),
  mounted() {
    this.headers = [
      {
        text: this.$t("withdrawalID"),
        value: "withdraw_id",
        sortable: false,
      },
      {
        text: this.$t("value"),
        value: "value_requested",
        sortable: true,
      },
      {
        text: this.$t("date"),
        value: "register_date",
        sortable: true,
        align: "center",
      },
      {
        text: this.$t("paymentProvider"),
        value: "gateway_name",
        sortable: false,
      },
      {
        text: "PIX",
        value: "key_pix",
        sortable: false,
      },
      {
        text: this.$t("typePix"),
        value: "type_key",
        sortable: false,
      },
      {
        text: this.$t("date"),
        value: "register_date",
        sortable: false,
      },
      {
        text: this.$t("idUser"),
        value: "id_player",
        sortable: false,
      },
      {
        text: this.$t("user"),
        value: "name_player",
        sortable: false,
      },
      {
        text: "IP",
        value: "ip",
        sortable: false,
      },
      {
        text: this.$t("status"),
        value: "statusUI",
      },
      {
        text: this.$t("actions"),
        value: "actions",
        align: "center",
        sortable: false,
      },
    ];
  },
  computed: {
    canAuthorizeWithdraw() {
      return this.$permission("6");
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    statusWithdraw() {
      return this.$store.state.filters.selectTypeBankStatement.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    goTo() {
      return this.$store.state.filters.TabsNavigationButtons.route;
    },
    paymentProvider() {
      return this.$store.state.filters.paymentProvider.value;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getData();
    },
    goTo(val) {
      this.$router
        .push({
          name: val,
        })
        .catch(() => {});
    },
  },
  methods: {
    withdrawSuccess() {
      this.getData();
    },
    withdrawCanceled({ withdraw_id, reason }) {
      this.datatableItems.forEach((item) => {
        if (item.withdraw_id == withdraw_id) {
          item.status = 4;
          item.showAction = item.status == 1 || item.status == 4 ? true : false;
          item.statusUI = this.statusOperationUI(item.status);
          item.statusIcon = this.statusSubtitle(item.status);
          item.error_gateway = reason;
        }
      });
    },
    updateIpHeader(hasOneIp) {
      const ipHeaderSet = this.headers.some((item) => item.value === "ip");

      if (ipHeaderSet && !hasOneIp) {
        this.headers = this.headers.filter((item) => item.value !== "ip");
        return;
      }

      if (!ipHeaderSet && hasOneIp) {
        const ipHeader = {
          text: "IP",
          value: "ip",
          sortable: false,
        };

        this.headers = [
          ...this.headers.slice(0, 7),
          ipHeader,
          ...this.headers.slice(7),
        ];
      }
    },
    reset() {
      this.datatableItems = [];
      // this.headers = [];
    },

    // Resquest API
    async getData() {
      this.reset();
      const body = {
        ...this.rangeDate,
        status: this.statusWithdraw,
        payment_provider: this.paymentProvider,
        export: this.exportDoc
      };

      let response;

      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/colab/bankOnline/listWithdraws",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/colab/bankOnline/listWithdraws",
          body
        );
      }

      if (!response.dados) return;
      
      try{
        const hasOneIp = response.dados.some(
          (item) => item.ip && item.ip != ""
        );
  
        this.updateIpHeader(hasOneIp);
  
        this.datatableItems = response.dados;
  
        // console.log(this.datatableItems);
        this.datatableItems.forEach((item) => {
          if (item.nome_metodo == "Carteira") {
            item.key_pix = this.$t("wallet");
          }
  
          item.register_date = new Date(
            item.register_date.replace(" ", "T")
          ).toLocaleString();
  
          item.type_key = this.typePix(item.type_key);
  
          item.value_requested = item.value_requested = (
            Number(item.value_requested) * -1
          ).toFixed(2);
          item.showAction =
            item.status == 1 || item.status == 4 ? true : false;
          item.statusUI = this.statusOperationUI(item.status);
          item.statusIcon = this.statusSubtitle(item.status);
        });
  
        this.buildResumeData(this.datatableItems);

      } catch(error){
        console.log(error)
      }


      // this.$request
      //   .post("/colab/bankOnline/listWithdraws", body)
      //   .then((response) => {
      //     if (!response.dados) return;

      //     const hasOneIp = response.dados.some(
      //       (item) => item.ip && item.ip != ""
      //     );

      //     this.updateIpHeader(hasOneIp);

      //     this.datatableItems = response.dados;

      //     // console.log(this.datatableItems);
      //     this.datatableItems.forEach((item) => {
      //       if (item.nome_metodo == "Carteira") {
      //         item.key_pix = this.$t("wallet");
      //       }

      //       item.register_date = new Date(
      //         item.register_date.replace(" ", "T")
      //       ).toLocaleString();

      //       item.type_key = this.typePix(item.type_key);

      //       item.value_requested = item.value_requested = (
      //         Number(item.value_requested) * -1
      //       ).toFixed(2);
      //       item.showAction =
      //         item.status == 1 || item.status == 4 ? true : false;
      //       item.statusUI = this.statusOperationUI(item.status);
      //       item.statusIcon = this.statusSubtitle(item.status);
      //     });

      //     this.buildResumeData(this.datatableItems);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },

    // resumo
    buildResumeData(datatableItems) {
      if (!datatableItems) return;

      const sum = (key) => {
        return datatableItems
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      let resume = {
        // value_consolidated: {},
        value_requested: {},
      };

      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
      });

      this.resume = { ...resume };
      this.resumePeriod = Object.keys(this.resume);

      // Create de Btn copy on resume to Excel
      this.resumeExcelCopy();
    },

    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `<table>
        <tr>${this.resume.value_requested.value
          .toString()
          .replace(".", ",")}</tr>
     </table>`;
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    // Legenda para chave Pix
    typePix(value) {
      if (value == "EMAIL") {
        return "E-mail";
      }
      if (value == "PHONE") {
        return this.$t("phone");
      }
      if (value == "EVP") {
        return this.$t("randomKey");
      } else {
        return "CPF";
      }
    },
    // Status for extratc
    statusOperationUI(value) {
      const obj = {
        1: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "requisted"
        )}</span></span>`,
        2: `<span class="my-1 v-chip theme--light v-size--small grey darken  white--text"><span class="v-chip__content">${this.$t(
          "authorized"
        )}</span></span>`,
        3: `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${this.$t(
          "consolidated"
        )}</span></span>`,
        4: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content">${this.$t(
          "didCancelled"
        )}</span></span>`,
      };
      return obj[value];
    },
    statusSubtitle(value) {
      const obj = {
        2: "mdi-progress-check",
        3: "mdi-check",
        4: "mdi-close-circle-outline",
      };
      return obj[value];
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        total: "Total",
        value_consolidated: this.$t("consolidatedValue"),
        value_requested: this.$t("withdrawals"),
      };
      return myKeysTranslated[key] || null;
    },
  },
};
</script>
